// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.ctm-device-wrap[data-v-aaab66aa] {\n    height: 240px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.ctm-no-data[data-v-aaab66aa] {\n    color: #94a3b8;\n    font-size: 14px;\n}\n", ""]);
// Exports
module.exports = exports;
